import React, { useState } from 'react'
import ListGroup from './partials/ListGroup';
import UserHero from './partials/UserHero';
import UserAccount from './partials/UserAccount';
import HomeProfile from './partials/HomeProfile';
import UserBooking from './partials/UserBooking';


export default function UserBookingPage() {

  return (
    <>
      <UserHero />
      <div className="container">
        <UserAccount />
        <div className="row overflow-hidden">
          <ListGroup />
          <UserBooking />
        </div>
      </div>





    </>
  )
}
